import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { AuthFrame } from '../../components/AuthFrame';
import { requireSupabase } from '../../lib/supabase';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const submit = async (event: FormEvent) => {
    event.preventDefault(); setMessage('');
    const { error } = await requireSupabase().auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/hub/reset-password`,
    });
    setMessage(error ? error.message : 'Reset instructions sent. Check your email.');
  };
  return (
    <AuthFrame eyebrow="Account recovery" title="Reset your password" description="We’ll send a secure reset link to the email connected to your account." footer={<Link to="/hub/login">Return to sign in</Link>}>
      <form className="auth-form" onSubmit={submit}>
        <label>Email<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
        {message && <div className="form-message">{message}</div>}
        <button className="button primary full">Send reset link</button>
      </form>
    </AuthFrame>
  );
}
